import { Box, Grid, Typography } from "@mui/material";
import FormField from "components/FormField";
import SelectField from "components/SelectField";
import { memo } from "react";
import DatepickerField from "components/DatepickerField";
import SwitchField from "components/SwitchField";
import FormNumberField from "components/FormNumberField";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
/* eslint-disable react/prop-types */

const countryOptions = [
  { value: "Value 1", label: "Value 1" },
  { value: "Value 2", label: "Value 2" },
];

function Fields12({ formData }) {
  const { formField12, values, errors, touched } = formData;
  const { provisionLevel, amountSetAside } = formField12;
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Grid spacing={3} container>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <SoftBox ml={0.5} lineHeight={0} display="inline-block">
            <SoftTypography component="label" variant="caption" fontWeight="bold">
              I. Xác định số trích lập Quỹ phát triển khoa học và công nghệ trong kỳ tính thuế
            </SoftTypography>
          </SoftBox>
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={provisionLevel.name}
            label={provisionLevel.label}
            value={values.provisionLevel}
            error={errors.provisionLevel && touched.provisionLevel}
            success={values.provisionLevel?.toString().length > 0 && !errors.provisionLevel}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={amountSetAside.name}
            label={amountSetAside.label}
            value={values.amountSetAside}
            error={errors.amountSetAside && touched.amountSetAside}
            success={values.amountSetAside?.toString().length > 0 && !errors.amountSetAside}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <SoftBox ml={0.5} lineHeight={0} display="inline-block">
            <SoftTypography component="label" variant="caption" fontWeight="bold">
              II. Theo dõi việc điều chuyển, sử dụng Quỹ phát triển khoa học và công nghệ các kỳ
              tính thuế trước và kỳ này:
            </SoftTypography>
          </SoftBox>
        </Grid>
      </Grid>
    </Box>
  );
}

export default memo(Fields12);
